import {
  InputBase,
  type InputBaseComponentProps,
  useTheme,
} from "@mui/material";
import { forwardRef } from "react";

export interface TextInputProps
  extends Omit<InputBaseComponentProps, "onChange"> {
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  id?: string;
  error?: boolean;
  errorColor?: string;
}

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ value, onChange, maxLength, id, sx, ...props }, ref) => {
    const { colors, customSpacing, radius, typography } = useTheme();

    return (
      <InputBase
        ref={ref}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{
          maxLength,
        }}
        id={id}
        sx={{
          width: "100%",
          minHeight: 40,
          fontFamily: typography.fontFamily,
          fontSize: typography.body1.fontSize,
          borderRadius: radius.md,
          gap: customSpacing.none,
          padding: `${customSpacing.xs} ${customSpacing.md}`,
          border: `1px solid ${colors.border.primary}`,
          background: colors.background.primary,
          color: colors.text.primary,
          boxSizing: "border-box",
          transition: "border-color 0.2s, box-shadow 0.2s",
          "&:focus": {
            outline: "none",
          },
          ...sx,
        }}
        {...props}
      />
    );
  },
);
